
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser's automatic scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Use a small timeout to ensure the page has rendered
    const scrollToTop = () => {
      // Force immediate scroll to top with instant behavior
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      
      // Fallback for browsers that don't support behavior: 'instant'
      window.scrollTo(0, 0);
      
      // Force document element scroll for mobile browsers
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Immediate scroll
    scrollToTop();
    
    // Additional timeout for mobile browsers that might need more time
    const timeoutId = setTimeout(scrollToTop, 50);
    
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
